import { createPalette, ERROR } from '@/theme/themes/colors';
import {
  DEFAULT_BACKGROUND_VALUES,
  DEFAULT_BUTTON_COLORS,
  TARGET_IDENTIFIERS
} from '../constants';

export const getPalette = (transformedBrandStyles: Record<string, any>) => {
  const basePalette = createPalette();

  const { page } = getPageBackgroundPalette(transformedBrandStyles);
  const { button } = getButtonColorsPalette(transformedBrandStyles);
  const { error } = getErrorPalette(transformedBrandStyles);

  return {
    ...basePalette,
    button,
    page,
    error,
    background: {
      default: page.background.main,
      secondary: DEFAULT_BACKGROUND_VALUES.secondary
    }
  };
};

export const getPageBackgroundPalette = (brandStyles: Record<string, any>) => {
  const pageBackgroundColor =
    brandStyles?.[TARGET_IDENTIFIERS.PAGE]?.backgroundColor ||
    DEFAULT_BACKGROUND_VALUES.primary;

  return {
    page: {
      background: {
        main: pageBackgroundColor
      }
    }
  };
};

export const getButtonColorsPalette = (brandStyles: Record<string, any>) => {
  const fontColor =
    brandStyles?.[TARGET_IDENTIFIERS.PRIMARY_BUTTON]?.color ||
    DEFAULT_BUTTON_COLORS.color;
  const bgColor =
    brandStyles?.[TARGET_IDENTIFIERS.PRIMARY_BUTTON]?.backgroundColor ||
    DEFAULT_BUTTON_COLORS.backgroundColor;
  const hoverFontColor =
    brandStyles?.[TARGET_IDENTIFIERS.PRIMARY_BUTTON_HOVER]?.color ||
    DEFAULT_BUTTON_COLORS.hoverColor;
  const hoverBgColor =
    brandStyles?.[TARGET_IDENTIFIERS.PRIMARY_BUTTON_HOVER]?.backgroundColor ||
    DEFAULT_BUTTON_COLORS.hoverBackgroundColor;

  return {
    button: {
      font: {
        main: fontColor,
        hover: hoverFontColor
      },
      background: {
        main: bgColor,
        hover: hoverBgColor
      }
    }
  };
};

export const getErrorPalette = (brandStyles: Record<string, any>) => {
  const color = brandStyles?.[TARGET_IDENTIFIERS.PAGE_ERROR]?.color || ERROR;

  return {
    error: {
      main: color
    }
  };
};
